import React from 'react';
import {AppContext} from "../../HomePage";
import AuthCustomerStrip from "./AuthCustomerStrip";

// Marketing column shown next to every auth form. eCOMSCANNER keeps the
// heading only, which is what the previous AuthInfo component did for it.
const AuthBrandPanel = () => {

    const {t, appName, host} = React.useContext(AppContext);

    // Each bullet carries the icon for what it actually says — price tracking,
    // MAP protection, automated repricing — rather than three identical ticks.
    const bullets = host === "ecomscanner" ? [] : [
        {icon: "pi-chart-line", text: t('login.value_prop_1')},
        {icon: "pi-shield", text: t('login.value_prop_2')},
        {icon: "pi-sync", text: t('login.value_prop_3')}
    ];

    // Both figures are the ones the marketing site already publishes, so the
    // two pages make the same claim. eCOMSCANNER is white-labelled and gets
    // neither the bullets nor these.
    const proof = host === "ecomscanner" ? [] : [
        {value: t('login.proof_countries_value'), label: t('login.proof_countries_label')},
        {value: t('login.proof_pages_value'), label: t('login.proof_pages_label')}
    ];

    return <div className="auth-ux__brand-inner">
        {host !== "ecomscanner" &&
        <img className="auth-ux__brand-logo" alt="PriceRest"
             src="/assets/layout/images/logo_white.png"/>}
        <h2 className="auth-ux__brand-title">{t('login.auth_info_msg_1', {appName: appName})}</h2>
        {bullets.length > 0 &&
        <ul className="auth-ux__bullets">
            {bullets.map((bullet, index) =>
                <li className="auth-ux__bullet" key={index}>
                    <i className={"pi " + bullet.icon}/>
                    <span>{bullet.text}</span>
                </li>)}
        </ul>}
        {proof.length > 0 &&
        <div className="auth-ux__proof">
            {proof.map((item, index) =>
                <div className="auth-ux__proof-item" key={index}>
                    <span className="auth-ux__proof-value">{item.value}</span>
                    <span className="auth-ux__proof-label">{item.label}</span>
                </div>)}
        </div>}
        <AuthCustomerStrip variant="dark"/>
    </div>;
};
export default AuthBrandPanel;
